import { Box, Button, TextField, Stack } from "@mui/material";
import { useCheckout } from "../CheckoutContext";

export default function ClientStep() {
    const { checkoutData, updateSection, nextStep } = useCheckout();

    const isValid =
        checkoutData.client.name &&
        checkoutData.client.email &&
        checkoutData.client.cpf;


    return (
        <Stack spacing={2}>
            <TextField
                label="Nome completo"
                value={checkoutData.client.name}
                onChange={(e) =>
                    updateSection("client", { name: e.target.value })
                }
                sx={{
                    "& .MuiInputLabel-root": {
                        color: "#6b7280",
                        fontSize: 14,
                    },
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                    },
                }}
            />
            <TextField
                label="E-mail"
                value={checkoutData.client.email}
                onChange={(e) =>
                    updateSection("client", { email: e.target.value })
                }
                sx={{
                    "& .MuiInputLabel-root": {
                        color: "#6b7280",
                        fontSize: 14,
                    },
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                    },
                }}
            />
            <TextField
                label="Telefone"
                value={checkoutData.client.phone}
                onChange={(e) =>
                    updateSection("client", { phone: e.target.value })
                }
                sx={{
                    "& .MuiInputLabel-root": {
                        color: "#6b7280",
                        fontSize: 14,
                    },
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                    },
                }}
            />
            <TextField
                label="CPF"
                value={checkoutData.client.cpf}
                onChange={(e) =>
                    updateSection("client", { cpf: e.target.value })
                }
                sx={{
                    "& .MuiInputLabel-root": {
                        color: "#6b7280",
                        fontSize: 14,
                    },
                    "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                    },
                }}
            />

            <Button
                variant="contained"
                disabled={!isValid}
                onClick={nextStep}
            >
                Continuar
            </Button>
        </Stack>
    );
}
